import React from "react";

function SelectInput({
  name,
  title,
  handleChange,
  selectedCategory,
  showLabel = false,
  children,
}) {
  return (
    <div>
      <label
        htmlFor={name}
        className={`${!showLabel ? "sr-only" : ""} text-gray-700`}
      >
        {title}
      </label>
      <select
        name={name}
        id={name}
        className={`input cursor-pointer text-base bg-gray-100 ${
          !showLabel ? "m-0" : ""
        }`}
        onChange={handleChange}
        value={selectedCategory}
      >
        {children}
      </select>
    </div>
  );
}

export default SelectInput;
